<template>
  <div class="boxbgcolor">
    <section
      class="right content-right list list-box"
      style="margin-top: 20px; padding: 0 20px; width: 100%;"
    >
      <div class="right-container">
        <!-- 查询条件 -->
        <div class="searchbox">
          <form action="#" method="get" class="form-inline form-float">
            <div class="form-group">
              <label for>道路:</label>
              <search-parking></search-parking>
            </div>
            <div class="form-group">
              <label for>锁类型:</label>
              <el-select v-model="search.lockType" placeholder="请选择锁类型" clearable style="width: 200px;">
                <el-option label="U型车锁" value="U型车锁"></el-option>
                <el-option label="平板车锁" value="平板车锁"></el-option>
                <el-option label="地埋车锁" value="地埋车锁"></el-option>
              </el-select>
            </div>
            <div class="form-group">
              <label for>锁编号:</label>
              <input
                v-model.trim="search.lockCode"
                class="form-control"
                type="text"
                placeholder="请输入锁编号"
                size="12"
                @keyup.enter="handleSearch"
              />
            </div>
            <div class="form-group">
              <label for>车位号:</label>
              <input
                v-model.trim="search.spaceNum"
                class="form-control"
                type="text"
                placeholder="请输入车位号"
                size="12"
                @keyup.enter="handleSearch"
              />
            </div>
            <div class="form-group">
              <label for>锁状态:</label>
              <el-select v-model="search.lockStatus" placeholder="请选择锁状态" clearable style="width: 200px;">
                <el-option label="在线" value="在线"></el-option>
                <el-option label="离线" value="离线"></el-option>
                <el-option label="故障" value="故障"></el-option>
              </el-select>
            </div>
            <div class="form-group others">
              <span class="search_btn">
                <button
                  @click="handleSearch"
                  type="button"
                  class="btn btn-primary"
                  id="search_btn"
                >
                  查询
                </button>
              </span>
              <span class="add_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  id="addarea"
                  @click="addOrEdit()"
                >
                  添加
                </button>
              </span>
              <span class="add_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="batchImport"
                >
                  批量导入
                </button>
              </span>
              <span class="add_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="download"
                >
                  导出
                </button>
              </span>
              <span class="add_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="openOperationModeDialog"
                  :disabled="!hasSelectedLocks"
                >
                  运营模式设置
                </button>
              </span>
              <span class="add_btn" style="position: relative;">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="goToAlarmEvent"
                >
                  告警事件
                </button>
                <span 
                  v-if="unprocessedAlarmCount > 0" 
                  class="alarm-badge"
                >
                  {{ unprocessedAlarmCount > 99 ? '99+' : unprocessedAlarmCount }}
                </span>
              </span>
            </div>
          </form>
        </div>
        
        <!-- 列表区域 -->
        <div class="list-container">
          <!-- <Chart
            v-if="isSelected === 'chart'"
            :parkingId="search.parkingId"
            :gatewayId="search.gatewayId"
          ></Chart> -->
          <List
            ref="listRef"
            v-if="isSelected === 'list'"
            :lockType="search.lockType"
            :lockCode="search.lockCode"
            :spaceNum="search.spaceNum"
            :lockStatus="search.lockStatus"
            @selection-change="handleSelectionChange"
          ></List>
        </div>
      </div>
    </section>
    <!--批量添加地锁-->
    <el-dialog
      :close-on-click-modal="false"
      title="批量添加地锁"
      :visible.sync="batchImportDialogFormVisible"
      width="500px"
      @closed="closeUpload"
    >
      <div class="downloadTemplate">
        <span class="downloadButtonText">
          <span class="tip">*</span>请先
          <span @click="bulkLoadTemplate" class="downloadButton">下载模板</span
          >，按照模板要求填入数据后，再上传文件
        </span>
      </div>
      <div class="upload">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/prod-api/park/lock/importData"
          :multiple="false"
          name="uploadFile"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileSuccess"
          :on-error="fileError"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
        <el-button @click="batchImportDialogFormVisible = false" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    
    <!-- 运营模式设置对话框 -->
    <el-dialog
      title="运营模式设置"
      :visible.sync="operationModeDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="operationModeForm" label-width="120px">
        <el-form-item label="运营模式">
          <el-select v-model="operationModeForm.mode" placeholder="请选择运营模式" style="width: 100%;">
            <el-option label="常降模式" value="常降模式"></el-option>
            <el-option label="人工模式" value="人工模式"></el-option>
            <el-option label="常升模式" value="常升模式"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模式说明">
          <div class="mode-description">
            <div  class="description-item">
              <strong>常降模式：</strong>无车时，车位锁挡板降下，有车时，挡板自动升起并开始计费，扫码支付后自动降锁驶离
            </div>
            <div  class="description-item">
              <strong>人工模式：</strong>车位锁挡板不进行自动升降，必须由运维人员或管理人员进行升降挡板
            </div>
            <div class="description-item">
              <strong>常升模式：</strong>无车时，挡板自动升起，需要停车时，只需要预约或者管理人员降锁后才能停车
            </div>
            <!-- <div v-if="!operationModeForm.mode" class="description-placeholder">
              请选择运营模式查看说明
            </div> -->
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operationModeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOperationMode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { addLock, equipWarn } from "@/api/url";
import SearchParking from "@/page/commons/searchParking";
// import Chart from "./chart.vue";
import List from "./list.vue";
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
export default {
  data() {
    return {
      batchImportDialogFormVisible: false,
      operationModeDialogVisible: false,
      isSelected: "list",
      search: {
        lockType: "", // 锁类型
        lockCode: "", // 锁编号
        spaceNum: "", // 车位号
        lockStatus: "", // 锁状态
      },
      operationModeForm: {
        mode: "",
      },
      selectedLocksCount: 0, // 选中的车锁数量
      unprocessedAlarmCount: 0, // 未处理的告警事件数量
      alarmCountTimer: null, // 定时器
    };
  },
  components: {
    SearchParking,
    // Chart,
    List,
  },
  computed: {
    // 检查是否有选中的车锁
    hasSelectedLocks() {
      return this.selectedLocksCount > 0;
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    ...mapActions("parking", ["setParking"]),
    
    // 查询
    handleSearch() {
      // 查询条件变化会自动触发子组件重新查询（通过 watch）
      // 这里可以添加其他逻辑，如果需要的话
    },
    
    // 重置
    handleReset() {
      this.search.lockType = "";
      this.search.lockCode = "";
      this.search.spaceNum = "";
      this.search.lockStatus = "";
      // 查询条件变化会自动触发子组件重新查询（通过 watch）
    },
    onSwitchClick(type) {
      this.isSelected = type;
    },
    addOrEdit(id) {
      // 调用子组件的添加/修改方法
      if (this.$refs.listRef) {
        this.$refs.listRef.addOrEdit(id);
      }
    },
    download() {
      this.$downloadFileRequest(
        "/prod-api/park/lock/export",
        {},
        "lora地锁"
      );
    },
    batchImport() {
      this.batchImportDialogFormVisible = true;
    },
    //批量上传
    submitUpload() {
      this.batchImportDialogFormVisible = false;

      this.$refs.upload.submit();
    },
    bulkLoadTemplate() {
      window.open("/prod-api/park/lock/importTemplate", "_self");
    },

    closeUpload() {
      this.$refs.upload.clearFiles();
    },
    fileSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      //   this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function () {
        _this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },
    fileError(err, file, fileList) {
      // console.log(err)
    },
    onTaskClick(){
        this.$router.push({path:'/main/equipment/lora-lock/task'})
    },
    // 处理选择变化
    handleSelectionChange(selectedRows) {
      this.selectedLocksCount = selectedRows ? selectedRows.length : 0;
    },
    // 打开运营模式设置对话框
    openOperationModeDialog() {
      if (!this.hasSelectedLocks) {
        this.$message.warning("请先选择要设置运营模式的车锁");
        return;
      }
      this.operationModeForm.mode = "";
      this.operationModeDialogVisible = true;
    },
    // 保存运营模式
    saveOperationMode() {
      if (!this.operationModeForm.mode) {
        this.$message.warning("请选择运营模式");
        return;
      }
      // TODO: 调用API保存运营模式设置
      // 这里需要根据实际API接口进行实现
      this.$message.success("运营模式设置成功");
      this.operationModeDialogVisible = false;
    },
    // 跳转到告警事件页面
    goToAlarmEvent() {
      this.$router.push({
        path: "/main/equipment/alarm",
        query: {
          tab: 'lock' // 默认显示地锁报警标签页
        }
      });
    },
    // 获取未处理的告警事件数量
    async getUnprocessedAlarmCount() {
      try {
        // 测试数据：暂时使用固定值
        this.unprocessedAlarmCount = 5; // 测试数据：5条未处理告警
        
        // 实际API调用（暂时注释）
        // const res = await this.$get(equipWarn(), {
        //   limit: 1,
        //   page: 1,
        //   isHandle: 'n', // 未处理
        // });
        // if (res && res.status === 200) {
        //   this.unprocessedAlarmCount = res.data?.total || 0;
        // } else {
        //   this.unprocessedAlarmCount = 0;
        // }
      } catch (error) {
        console.error("获取未处理告警数量失败:", error);
        this.unprocessedAlarmCount = 0;
      }
    },
  },
  mounted() {
    // 获取未处理告警数量
    this.getUnprocessedAlarmCount();
    // 每30秒刷新一次未处理告警数量
    this.alarmCountTimer = setInterval(() => {
      this.getUnprocessedAlarmCount();
    }, 30000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.alarmCountTimer) {
      clearInterval(this.alarmCountTimer);
    }
  },
  watch: {
    // 监听 Vuex 中停车场变化（可选，用于过滤数据）
    'parking.parkingId': {
      handler: function(newVal) {
        // 如果需要在选择道路时重置查询条件，可以在这里处理
        // 目前不强制要求选择道路，所以注释掉
        // if (newVal) {
        //   this.search.lockType = "";
        //   this.search.lockCode = "";
        //   this.search.spaceNum = "";
        //   this.search.lockStatus = "";
        // }
      },
    },
  },
};
</script>
<style scoped>
.boxbgcolor {
  width: 100% !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-right {
  width: 100% !important;
}

.list.list-box {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100% !important;
  flex: 1;
  margin-left: 0 !important;
}

.right-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #f5f7fa;
  overflow: hidden;
}

.list-container {
  flex: 1;
  overflow: hidden;
  background: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
}

.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}

.mode-description {
  min-height: 60px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.description-item {
  color: #606266;
  line-height: 1.8;
  font-size: 14px;
}

.description-item strong {
  color: #303133;
  font-weight: 600;
}

.description-placeholder {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
}

.alarm-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #F56C6C;
  color: #fff;
  border-radius: 10px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  padding: 0 6px;
  box-sizing: border-box;
  font-weight: bold;
  border: 2px solid #fff;
  z-index: 10;
}
</style>
